/**
 * Created by wafer on 2017/5/23.
 */
import request, { requestNoToken } from '../utils/request';
import { Base64 } from 'js-base64';
import { AES, enc, mode, pad } from 'crypto-js';

const SECRET_KEY = enc.Latin1.parse('dbd-d3d5-436a15d');
const SECRET_IV = enc.Latin1.parse('1234067802344678');

export const login = ({
  username,
  password,
  checkCode,
  checkCodeKey,
  basedn,
  locale,
  checkCodeFlag
}) => {
  const encPassword = AES.encrypt(password, SECRET_KEY, {
    iv: SECRET_IV,
    mode: mode.CBC,
    padding: pad.ZeroPadding
  }).toString();

  const json = {
    userId: username,
    password: encPassword,
    basedn: basedn,
    verifyCode: checkCode,
    checkCodeFlag: checkCodeFlag,
    key: checkCodeKey,
    lang: locale
  };

  return requestNoToken(`/iwork/login/go?clientType=pc&version=`, {
    method: 'POST',
    body: JSON.stringify(json)
  });
};

export const validateDomain = ({ domainName, locale }) => {
  return request(
    `/iwork/domain/checkDomain?domain=${domainName}&lang=${locale}`
  );
};

export const validateUser = ({ user, token, locale }) => {
  //flag：标识位(1-用户名|2-手机号|3-邮箱)
  //num：用户名或手机号或邮箱
  return request(
    `/iwork/userInfo/checkUser?num=${user.num}&domain=${user.domainName ||
      ''}&lang=${locale}&flag=${user.flag}&userId=${user.userId || ''}`
  );
};

export const registerDomain = ({ register, token, locale }) => {
  const uri = `/iwork/userInfo/registUser?flag=0&noticeType=${
    register.noticeType
  }&domainName=${register.domainName}&name=${register.name}&userId=${
    register.userId
  }&password=${encodeURIComponent(
    Base64.encode(register.password)
  )}&firstName=${register.firstName}&givenName=${register.givenName}&mobile=${
    register.mobile
  }&email=${register.email}&lang=${locale}&verifyCode=${register.verifyCode ||
    ''}`;
  return request(uri);
};

export const msmValidate = ({
  domainName,
  mobile,
  locale,
  flag,
  account,
  checkCode,
  checkCodeKey,
  checkCodeFlag
}) => {
  const uri = `/iwork/domain/sendSmsVerifyCode?domain=${domainName}&phone=${mobile}&lang=${locale}&flag=${flag}&account=${account}&verifyCode=${checkCode}&key=${checkCodeKey}&checkCodeFlag=${checkCodeFlag}`;
  return request(uri);
};

export const getDomain = ({ domainName, locale }) => {
  return request(`/iwork/domain/getDomain?name=${domainName}&lang=${locale}`);
};

export const activeDomainFromEmail = ({ email, locale, domainName }) => {
  return request(
    `/iwork/domain/activeDomain?email=${email}&lang=${locale}&name=${domainName}`
  );
};
export const forgotPasswordEmail = ({
  num,
  verifyCode,
  key,
  locale,
  account,
  checkCodeFlag
}) => {
  return requestNoToken(
    `/iwork/userInfo/forgetPwdEmail?num=${num}&verifyCode=${verifyCode}&lang=${locale}&account=${account}&key=${key}&checkCodeFlag=${checkCodeFlag}`
  );
};
export const forgotPasswordMobile = ({ num, verifyCode, locale, account }) => {
  return requestNoToken(
    `/iwork/userInfo/forgetPwdMobile?num=${num}&verifyCode=${verifyCode}&lang=${locale}&account=${account}`
  );
};

//resetType 重置密码时为true
export const modifyPassword = ({ userId, pwd, locale, resetType }) => {
  let uri = `/iwork/userInfo/updatePwd?userId=${userId}&pwd=${encodeURIComponent(
    Base64.encode(pwd)
  )}&lang=${locale}&resetType=${resetType ? resetType : 0}`;
  return request(uri);
};

/**
 * 获得验证码接口
 */
export const getCheckCode = () => {
  const uri = '/iwork/verifyCode/create';
  return requestNoToken(uri);
};

export const loginByDomain = ({ domain, password }) => {
  return requestNoToken(
    `/iwork/login/loginByDomain?domain=${domain}&password=${encodeURIComponent(password)}`
  );
};

/**
 * 获取库里面验证码是否显示的配置
 */
export const getFlagWithVerifyCode = () => {
  const uri = '/iwork/verifyCode/getFlagWithVerifyCode';
  return requestNoToken(uri);
};



// WEBPACK FOOTER //
// ./src/services/login.js